<template>
  <div>
    <b-row class="print">
      <b-col>
        <p style="text-align: justify">
          Os <strong>CONTRATANTES</strong> declaram, para fins de direito, e sob
          as penas da lei, que as informações prestadas no ato de preenchimento
          do Requerimento de Matrícula e constantes no
          <strong>CONTRATO</strong>, são verdadeiras e eximem a
          <strong>CONTRATADA</strong> de quaisquer responsabilidades que possam
          advir de omissões e/ou inverdades prestadas no referido ato.
        </p>
      </b-col>
    </b-row>
    <TemplateViewContract :formEnroll="value" :gradeName="value.gradeName" />
  </div>
</template>

<script>
import TemplateViewContract from "@/components/templates/TemplateViewContract";
export default {
  name: "Print",
  components: {
    TemplateViewContract,
  },

  props: {
    value: {
      type: Object,
    },
  },

  data() {
    return {
      showDocs: null,
    };
  },

};
</script>

<style lang="scss" scoped>
//
</style>
